import { all, fork, call, put, takeLatest } from 'redux-saga/effects'
import { constants } from '../modules/contractActions'
import * as api from '../api/contracts'

function* getContractPaymentScheduleTemplate(action) {
  try {
    const payload = yield call(api.getContractPaymentScheduleTemplate, action.templateId)

    yield put({ type: constants.GET_CONTRACT_PAYMENT_SCHEDULE_TEMPLATE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CONTRACT_PAYMENT_SCHEDULE_TEMPLATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchgetContractPaymentScheduleTemplate() {
  yield takeLatest(
    constants.GET_CONTRACT_PAYMENT_SCHEDULE_TEMPLATE.ACTION,
    getContractPaymentScheduleTemplate
  )
}

function* getContractPaymentSchedule(action) {
  try {
    const payload = yield call(api.getContractPaymentSchedule, action.contractId)

    yield put({ type: constants.GET_CONTRACT_PAYMENT_SCHEDULE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CONTRACT_PAYMENT_SCHEDULE.FAILED,
      message: e.message || e
    })
  }
}

function* watchgetContractPaymentSchedule() {
  yield takeLatest(constants.GET_CONTRACT_PAYMENT_SCHEDULE.ACTION, getContractPaymentSchedule)
}

export function* rootSaga() {
  yield all([fork(watchgetContractPaymentScheduleTemplate), fork(watchgetContractPaymentSchedule)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/contractSaga.js